'use client'

import { useTranslations } from 'next-intl'

export function ScrollCue() {
  const t = useTranslations('hero')
  return (
    <>
      <style>{`
        @keyframes hero-drip {
          0%   { top: -16px; opacity: 0; }
          20%  { opacity: 1; }
          80%  { opacity: 1; }
          100% { top: 100%; opacity: 0; }
        }
        @media (prefers-reduced-motion: reduce) {
          .hero-drip { animation: none !important; }
        }
      `}</style>
      <div
        aria-hidden="true"
        id="hero-scroll-cue"
        style={{
          position: 'absolute',
          left: '50%', transform: 'translateX(-50%)',
          bottom: 36, zIndex: 25,
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14,
        }}
      >
        <span style={{
          fontFamily: 'var(--font-body)',
          fontSize: 10, fontWeight: 600,
          letterSpacing: '0.36em', textTransform: 'uppercase',
          color: 'rgba(81,50,5,0.85)',
        }}>
          {t('scrollCueLabel')}
        </span>

        {/* Drip line */}
        <span style={{
          display: 'block', width: 1, height: 56,
          background: 'linear-gradient(to bottom, rgba(81,50,5,0.55) 0%, rgba(81,50,5,0.05) 100%)',
          position: 'relative', overflow: 'hidden',
        }}>
          <span
            className="hero-drip"
            style={{
              position: 'absolute', left: 0, right: 0, height: 16,
              background: 'linear-gradient(to bottom, rgba(91,112,5,0) 0%, rgba(91,112,5,0.9) 100%)',
              animation: 'hero-drip 2.6s cubic-bezier(0.22,1,0.36,1) infinite',
            }}
          />
        </span>

        <span style={{
          fontFamily: 'var(--font-serif)', fontStyle: 'italic',
          fontSize: 14, color: 'rgba(81,50,5,0.72)',
          letterSpacing: '0.02em',
        }}>
          {t('scrollCueChapter')}
        </span>
      </div>
    </>
  )
}
